import { useRecoilValue, useSetRecoilState } from 'recoil';
import { sspSubmitOrder, draftTeams as recoilStoreDraftTeams } from 'pages/provisioning/day2/github-onboarding-new/store';
import { syncCustomTeamName } from 'pages/provisioning/day2/github-onboarding-new/utils';

const useSetNewCustomTeamName = () => {
    const order = useRecoilValue(sspSubmitOrder);
    const setNewTeams = useSetRecoilState(recoilStoreDraftTeams);

    return (index) =>
        ({ customName, categorization }) => {
            setNewTeams((prev) =>
                prev.map((team, i) => {
                    if (i !== index || team.isDefault) return team;

                    const updated = {
                        ...team,
                        customName: customName ?? team.customName,
                        categorization: categorization ?? team.categorization,
                    };

                    if (categorization && categorization !== team.categorization) {
                        updated.members = [];
                    }

                    return syncCustomTeamName(updated, order);
                })
            );
        };
};

export default useSetNewCustomTeamName;
